export default function useErrorToString() {
    return (e) => {
        if (!e) return "";
        if (e.message) return e.message;
        if (typeof e === "string") return e;
        if (typeof e === "object") return JSON.stringify(e);
        return "An error occurred";
    };
}
